var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTechnology = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Computer-Chip--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Computer Chip Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.43 11H1a1 1 0 0 0 0 2h1.43a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43 16H1a1 1 0 0 0 0 2h1.43a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43 6.5H1a1 1 0 0 0 0 2h1.43a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 11h-1.43a1 1 0 0 0 0 2H23a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.57 8.5H23a1 1 0 0 0 0 -2h-1.43a1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16h-1.43a1 1 0 0 0 0 2H23a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.44a1 1 0 0 0 1 -1V1a1 1 0 0 0 -2 0v1.44a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.44a1 1 0 0 0 1 -1V1a1 1 0 0 0 -2 0v1.44a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.44a1 1 0 0 0 1 -1V1a1 1 0 0 0 -2 0v1.44a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.57a1 1 0 0 0 -1 1V23a1 1 0 0 0 2 0v-1.43a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.57a1 1 0 0 0 -1 1V23a1 1 0 0 0 2 0v-1.43a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.57a1 1 0 0 0 -1 1V23a1 1 0 0 0 2 0v-1.43a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.07 4.5H5.93A1.43 1.43 0 0 0 4.5 5.93v12.14a1.43 1.43 0 0 0 1.43 1.43h12.14a1.43 1.43 0 0 0 1.43 -1.43V5.93a1.43 1.43 0 0 0 -1.43 -1.43Zm-1.57 11a1 1 0 0 1 -1 1H13a1 1 0 0 1 0 -2h2.5a1 1 0 0 1 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTechnology);
export default ForwardRef;